import { createAction } from 'redux-actions';
import { v4 as uuid } from 'uuid';
import queryString from 'query-string';
import * as TYPES from './types';
import * as messagingApi from '../../api/messaging';

export const setPending = createAction(TYPES.SET_PENDING);
export const setNotificationsData = createAction(TYPES.SET_NOTIFICATIONS_DATA);
export const setNotificationsPending = createAction(TYPES.SET_NOTIFICATIONS_PENDING);
export const setNotificationTokens = createAction(TYPES.SET_NOTIFICATIONS_TOKENS);
export const setNotificationFavoriteTokens = createAction(TYPES.SET_NOTIFICATIONS_FAVORITE_TOKENS);
export const setNotificationsTemplates = createAction(TYPES.SET_NOTIFICATIONS_TEMPLATES);
export const setNotificationsPage = createAction(TYPES.SET_NOTIFICATIONS_PAGE_NUMBER);
export const setNotificationsPageItems = createAction(TYPES.SET_NOTIFICATIONS_PAGE_ITEM_COUNT);

export const getNotifications = () => async (dispatch, getState) => {
  const {
    messaging: {
      notifications: { pageNumber, pageItemCount },
    },
  } = getState();

  dispatch(setNotificationsPending(true));
  try {
    const notifications = await messagingApi.getNotifications(queryString.stringify({ pageNumber, pageItemCount }));
    dispatch(setNotificationsData(notifications));
    return notifications;
  } catch (error) {
    console.log('[GET NOTIFICATIONS ERROR]', error);
    throw error;
  } finally {
    dispatch(setNotificationsPending(false));
  }
};

export const sendNotificationMessage = (data) => async (dispatch) => {
  dispatch(setPending(true));
  try {
    const response = await messagingApi.sendNotification(data);
    console.log('SENT RES: ', response);
    return response;
  } catch (error) {
    console.log('[SEND MESSAGE ERROR]', error);
    throw error;
  } finally {
    dispatch(setPending(false));
  }
};

export const addNotificationToken = (token) => (dispatch, getState) => {
  const {
    messaging: { notificationTokens },
  } = getState();

  dispatch(setNotificationTokens([...notificationTokens, token]));
};

export const addNotificationTokensToFavorite = (toks) => (dispatch, getState) => {
  const {
    messaging: { notificationFavoriteTokens, notificationTokens },
  } = getState();

  const filteredTokens = notificationTokens.filter((t) => !toks.includes(t));
  const filteredFavoriteTokens = notificationFavoriteTokens.filter((t) => !toks.includes(t));
  dispatch(setNotificationFavoriteTokens([...filteredFavoriteTokens, ...notificationTokens]));
  dispatch(setNotificationTokens(filteredTokens));
};

export const removeNotificationFavoriteToken = (token) => (dispatch, getState) => {
  const {
    messaging: { notificationFavoriteTokens },
  } = getState();

  const filteredTokens = notificationFavoriteTokens.filter((t) => t !== token);

  dispatch(setNotificationFavoriteTokens(filteredTokens));
};

export const removeNotificationToken = (token) => (dispatch, getState) => {
  const {
    messaging: { notificationTokens },
  } = getState();

  const filteredTokens = notificationTokens.filter((t) => t !== token);

  dispatch(setNotificationTokens(filteredTokens));
};

export const addNotificationTemplate = (template) => (dispatch, getState) => {
  const {
    messaging: { notificationTemplates },
  } = getState();

  dispatch(
    setNotificationsTemplates([
      ...notificationTemplates,
      {
        ...template,
        id: uuid(),
      },
    ]),
  );
};

export const removeNotificationTemplate = (id) => (dispatch, getState) => {
  const {
    messaging: { notificationTemplates },
  } = getState();

  const filteredTemplates = notificationTemplates.filter((t) => t.id !== id);
  dispatch(setNotificationsTemplates(filteredTemplates));
};

export const setCampaignsData = createAction(TYPES.SET_CAMPAIGNS_DATA);
export const setCampaignsPending = createAction(TYPES.SET_CAMPAIGNS_PENDING);
export const setCampaignsPage = createAction(TYPES.SET_CAMPAIGNS_PAGE_NUMBER);
export const setCampaignsPageItems = createAction(TYPES.SET_CAMPAIGNS_PAGE_ITEM_COUNT);

export const getCampaigns = () => async (dispatch, getState) => {
  const {
    messaging: {
      campaigns: { pageNumber, pageItemCount },
    },
  } = getState();

  dispatch(setCampaignsPending(true));
  try {
    const campaigns = await messagingApi.getCampaigns(queryString.stringify({ pageNumber, pageItemCount }));
    dispatch(setCampaignsData(campaigns));
    return campaigns;
  } catch (error) {
    console.log('[GET CAMPAIGNS ERROR]', error);
    throw error;
  } finally {
    dispatch(setCampaignsPending(false));
  }
};

export const createCampaign = (data) => async (dispatch) => {
  dispatch(setPending(true));
  try {
    return await messagingApi.createCampaign(data);
  } catch (error) {
    console.log('[CREATE CAMPAIGN ERROR]', error);
    throw error;
  } finally {
    dispatch(setPending(false));
  }
};

export const cancelCampaign = (id) => async (dispatch) => {
  dispatch(setCampaignsPending(true));
  try {
    await messagingApi.cancelCampaign(id);
  } catch (error) {
    console.log('[CANCEL CAMPAIGN ERROR]', error);
    throw error;
  } finally {
    dispatch(setCampaignsPending(false));
  }
  return dispatch(getCampaigns());
};

export const countCampaignAudience = (audience) => async (dispatch) => {
  dispatch(setPending(true));
  try {
    const { count } = await messagingApi.countCampaignAudience(audience);
    return count;
  } catch (error) {
    console.log('[COUNT AUDIENCE ERROR]', error);
    throw error;
  } finally {
    dispatch(setPending(false));
  }
};
